export const constants = {
  healthConditions: {
    title: "Health Conditions",
    addButtonTitle: "Add Health Condition",
    noRecordsMatch: "No matches found. Please try another search.",
    noRecords: "No Health Condition added yet.",
  },
  healthConditionDetails: {
    title: "Health Condition Details",
    backButton: " Back to Health Conditions",
  },
};
